// Rajada de festas a partir de um elemento: neve com faíscas douradas no Natal, confete dourado no Réveillon.
// Serve para o easter egg da logo com gorro (que balança como um enfeite), para o selo do cabeçalho e para as
// portas do calendário do Advento.
//   origin: ponto de saída em fração da caixa do elemento ({x: 0.5, y: 0.5} = centro)
//   sway:   balança o próprio elemento (logo)
//   amount: quantidade de peças
//   palette: cores do confete (padrão: dourado do Réveillon)
import {prefersReducedMotion} from './season';

// Onde fica o gorro na arte da logo com gorro, e o alto do quebra-cabeça na logo sem gorro
const HAT = {x: 0.14, y: 0.2};
const PUZZLE = {x: 0.1, y: 0.18};
const CONFETTI = ['#f3d68a', '#e2b85c', '#c8973c', '#fff4cf', '#d9ad55', '#5eead4'];

const playing = new WeakSet();

export default function seasonBurst(element, {newYear = false, origin = null, sway = false, amount = 26, palette = CONFETTI} = {}) {
    if (!element?.animate || prefersReducedMotion() || playing.has(element)) return;
    playing.add(element);
    setTimeout(() => playing.delete(element), 1100);

    if (sway) {
        // Balanço amortecido: bate, volta e assenta, girando em volta do quebra-cabeça
        element.style.transformOrigin = '18% 78%';
        element.animate([
            {transform: 'rotate(0deg)'},
            {transform: 'rotate(-6deg)', offset: 0.18},
            {transform: 'rotate(4.5deg)', offset: 0.4},
            {transform: 'rotate(-2.5deg)', offset: 0.62},
            {transform: 'rotate(1deg)', offset: 0.82},
            {transform: 'rotate(0deg)'},
        ], {duration: 1100, easing: 'ease-out'});
    }

    const box = element.getBoundingClientRect();
    const at = origin || (newYear ? PUZZLE : HAT);
    const originX = box.left + box.width * at.x;
    const originY = box.top + box.height * at.y;

    for (let i = 0; i < amount; i++) {
        const gold = i % 5 === 0;
        const piece = document.createElement('span');
        let size = gold ? 5 : 3 + Math.random() * 4;
        if (newYear && !gold) {
            piece.className = 'season-burst-confetti';
            piece.style.background = palette[i % palette.length];
            piece.style.height = `${size * 1.6}px`;
            size *= 0.75;
        } else {
            piece.className = gold ? 'season-burst-spark' : 'season-burst-flake';
            piece.style.height = `${size}px`;
        }
        Object.assign(piece.style, {left: `${originX}px`, top: `${originY}px`, width: `${size}px`});
        document.body.appendChild(piece);

        // Sai para cima e para os lados, depois cai devagar com um pouco de vento
        const angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.15;
        const force = 26 + Math.random() * 40;
        const upX = Math.cos(angle) * force;
        const upY = Math.sin(angle) * force;
        const drift = (Math.random() - 0.3) * 50;
        const fall = 70 + Math.random() * 90;
        const turn = newYear ? (Math.random() - 0.5) * 900 : 0;
        const animation = piece.animate([
            {transform: 'translate(0, 0) rotate(0deg) scale(0.3)', opacity: 0},
            {transform: `translate(${upX}px, ${upY}px) rotate(${turn * 0.25}deg) scale(1)`, opacity: 1, offset: 0.22},
            {transform: `translate(${upX + drift * 0.6}px, ${upY + fall * 0.55}px) rotate(${turn * 0.65}deg) scale(0.95)`, opacity: 0.9, offset: 0.65},
            {transform: `translate(${upX + drift}px, ${upY + fall}px) rotate(${turn}deg) scale(0.7)`, opacity: 0},
        ], {
            duration: 1500 + Math.random() * 900,
            delay: Math.random() * 120,
            easing: 'cubic-bezier(0.25, 0.6, 0.4, 1)',
            fill: 'both',
        });
        animation.onfinish = () => piece.remove();
        animation.oncancel = () => piece.remove();
    }
}
